import { DateObjectType } from '@typings/common';
import dayjs from 'dayjs';

const validateReviewDateMessage = (
  currentValue: string,
  date: DateObjectType
): string => {
  // Ensure each value is treated as a string and trimmed
  const day = (date.day || '').trim();
  const month = (date.month || '').trim();
  const year = (date.year || '').trim();

  const isAnyFieldFilled = day || month || year;

  if (isAnyFieldFilled) {
    // Check if all fields are filled
    if (!day || !month || !year) {
      return 'Please enter a valid date';
    }

    // Construct padded date string (e.g. "2025-03-09")
    const paddedDate = `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    // Check if date is valid
    const isValidDate = dayjs(paddedDate, 'YYYY-MM-DD', true).isValid();
    if (!isValidDate) {
      return 'Please enter a valid date';
    }
  }

  return '';
};

export default validateReviewDateMessage;
